module.exports = __webpack_public_path__ + "img/app3.fac3f0b2.png";